/**
 * ACTION PHOTO DOCUMENT RELABEL INIT
 * Reset relabel photo document
 */
export const viewerPhotoDocumentRelabelInit = () => {
  return (dispatch) => {
    dispatch({ type: 'VIEWER_PHOTO_DOCUMENT_RELABEL_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT RELABEL
 * Relabel photo document
 * @param {object} data - data id
 */
export const viewerPhotoDocumentRelabel = ({ id }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && id !== undefined) {
      dispatch({
        type: 'VIEWER_PHOTO_DOCUMENT_RELABEL_PENDING',
      });
      const firestore = getFirebase().firestore();

      const updateObject = {
        rejected: false,
        'vinne_annotation.annotated': false,
        'vinne_verification.verified': false,
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .update(updateObject)
        .then(() => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENT_RELABEL_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENT_RELABEL_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENT REJECT INIT
 * Reset reject photo document
 */
export const viewerPhotoDocumentRejectInit = () => {
  return (dispatch) => {
    dispatch({ type: 'VIEWER_PHOTO_DOCUMENT_REJECT_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT REJECT
 * Reject photo document
 * @param {object} data - data id
 */
export const viewerPhotoDocumentReject = ({ id }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && id !== undefined) {
      dispatch({
        type: 'VIEWER_PHOTO_DOCUMENT_REJECT_PENDING',
      });
      const firestore = getFirebase().firestore();

      const updateObject = {
        rejected: true,
        reserved: false,
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .update(updateObject)
        .then(() => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENT_REJECT_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENT_REJECT_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENT DELETE INIT
 * Reset delete photo document
 */
export const viewerPhotoDocumentDeleteInit = () => {
  return (dispatch) => {
    dispatch({ type: 'VIEWER_PHOTO_DOCUMENT_DELETE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT DELETE
 * Delete photo document
 * @param {object} data - data id
 */
export const viewerPhotoDocumentDelete = ({ id }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && id !== undefined) {
      dispatch({
        type: 'VIEWER_PHOTO_DOCUMENT_DELETE_PENDING',
      });
      const firebase = getFirebase();
      const firestore = firebase.firestore();

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .get()
        .then(async (snapshot) => {
          const photoDocument = snapshot.data();
          if (photoDocument.video_id) {
            try {
              await firebase
                .storage()
                .ref()
                .child(`waste_photos/${photoDocument.video_id}.mp4`)
                .delete();
            } catch (err) {}
          } else if (photoDocument.photo_id) {
            try {
              await firebase
                .storage()
                .ref()
                .child(`waste_photos/${photoDocument.photo_id}.jpg`)
                .delete();
            } catch (err) {}
          }
          await firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id)
            .delete();
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENT_DELETE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENT_DELETE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS RELABEL INIT
 * Reset relabel photo documents
 */
export const viewerPhotoDocumentsRelabelInit = () => {
  return (dispatch) => {
    dispatch({ type: 'VIEWER_PHOTO_DOCUMENTS_RELABEL_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENTS RELABEL
 * Relabel photo documents
 * @param {object} data - data id
 */
export const viewerPhotoDocumentsRelabel = ({ ids }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && ids !== undefined) {
      dispatch({
        type: 'VIEWER_PHOTO_DOCUMENTS_RELABEL_PENDING',
      });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const updateObject = {
        rejected: false,
        'vinne_annotation.annotated': false,
        'vinne_verification.verified': false,
      };

      ids.forEach((id) => {
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then((res) => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENTS_RELABEL_SUCCESS',
          });
          return res;
        })
        .catch((err) => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENTS_RELABEL_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS REJECT INIT
 * Reset reject photo documents
 */
export const viewerPhotoDocumentsRejectInit = () => {
  return (dispatch) => {
    dispatch({ type: 'VIEWER_PHOTO_DOCUMENTS_REJECT_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENTS REJECT
 * Reject photo documents
 * @param {object} data - data ids
 */
export const viewerPhotoDocumentsReject = ({ ids }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && ids !== undefined) {
      dispatch({
        type: 'VIEWER_PHOTO_DOCUMENTS_REJECT_PENDING',
      });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const updateObject = {
        rejected: true,
        reserved: false,
      };

      ids.forEach((id) => {
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then((res) => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENTS_REJECT_SUCCESS',
          });
          return res;
        })
        .catch((err) => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENTS_REJECT_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS DELETE INIT
 * Reset delete photo documents
 */
export const viewerPhotoDocumentsDeleteInit = () => {
  return (dispatch) => {
    dispatch({ type: 'VIEWER_PHOTO_DOCUMENTS_DELETE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENTS DELETE
 * Delete photo documents
 * @param {object} data - data ids
 */
export const viewerPhotoDocumentsDelete = ({ ids }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && ids !== undefined) {
      dispatch({
        type: 'VIEWER_PHOTO_DOCUMENTS_DELETE_PENDING',
      });
      const firebase = getFirebase();
      const firestore = firebase.firestore();
      const batch = firestore.batch();

      const viewerPhotoDocumentsDeleteMedia = async (id) => {
        return await firestore
          .collection('companies')
          .doc(profileCompany.id)
          .collection('photos')
          .doc(id)
          .get()
          .then(async (snapshot) => {
            const photoDocument = snapshot.data();
            dispatch({
              type: 'VIEWER_PHOTO_DOCUMENT_MEDIA_DELETE_PENDING',
            });
            if (photoDocument.video_id) {
              await firebase
                .storage()
                .ref()
                .child(`waste_photos/${photoDocument.video_id}.mp4`)
                .delete();
            } else if (photoDocument.photo_id) {
              await firebase
                .storage()
                .ref()
                .child(`waste_photos/${photoDocument.photo_id}.jpg`)
                .delete();
            }
            dispatch({
              type: 'VIEWER_PHOTO_DOCUMENT_MEDIA_DELETE_SUCCESS',
            });
            return true;
          })
          .catch((err) => {
            dispatch({
              type: 'VIEWER_PHOTO_DOCUMENT_MEDIA_DELETE_ERROR',
              err,
            });
            return false;
          });
      };

      await Promise.all(
        ids.map(async (id) => await viewerPhotoDocumentsDeleteMedia(id))
      );
      ids.forEach((id) => {
        batch.delete(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id)
        );
      });

      return await batch
        .commit()
        .then((res) => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENTS_DELETE_SUCCESS',
          });
          return res;
        })
        .catch((err) => {
          dispatch({
            type: 'VIEWER_PHOTO_DOCUMENTS_DELETE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};
